/**
 * Copies the assistant reply as **raw markdown** (syntax preserved for editors / MD paste).
 * @param {string} markdown
 */
export async function copyMarkdown(markdown) {
  const text = markdown ?? '';
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  throw new Error('Clipboard not available');
}

/**
 * Copies the assistant reply as BOTH raw markdown (text/plain) and rendered
 * HTML (text/html) so the paste renders correctly in both markdown-aware
 * tools (Slack, Notion, GitHub, Obsidian, VS Code, …) and rich-text editors
 * (Word, Outlook, Gmail, Google Docs, …).
 *
 * Falls back to plain `writeText(markdown)` when `ClipboardItem` /
 * `clipboard.write` is unavailable.
 *
 * @param {string} markdown — original markdown source for the message
 * @param {HTMLElement | null} renderedRoot — container that includes `.ddv-ai-chat__markdown`
 */
export async function copySmartFromRendered(markdown, renderedRoot) {
  const raw = markdown ?? '';
  const markdownEl = renderedRoot?.querySelector?.('.ddv-ai-chat__markdown');
  const fragment = markdownEl?.innerHTML?.trim() ?? '';

  if (
    fragment &&
    typeof ClipboardItem !== 'undefined' &&
    navigator.clipboard?.write
  ) {
    const htmlDoc = `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body><!--StartFragment-->${fragment}<!--EndFragment--></body></html>`;
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([htmlDoc], { type: 'text/html' }),
        'text/plain': new Blob([raw], { type: 'text/plain' }),
      }),
    ]);
    return;
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(raw);
    return;
  }

  throw new Error('Clipboard not available');
}
